import * as types from "../../actions/organizations/types";

const initialState = {
  isInitialLoaded: false,
  isInitialFetching: false,
  hasFetchError: false,
  initialList: [],
  autocomplete: {},
};

export default function organizations(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_INITIAL_ORGANIZATIONS_REQUEST: {
      return Object.assign({}, state, {
        isInitialFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_INITIAL_ORGANIZATIONS_SUCCESS: {
      return Object.assign({}, state, {
        isInitialFetching: false,
        isInitialLoaded: true,
        initialList: action.organizations,
      });
    }
    case types.FETCH_INITIAL_ORGANIZATIONS_FAILURE: {
      return Object.assign({}, state, {
        isInitialFetching: false,
        isInitialLoaded: false,
        hasFetchError: true,
      });
    }

    case types.FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST: {
      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: {
          isFetching: true,
          isLoaded: false,
          list: [],
        },
      });

      return Object.assign({}, state, { autocomplete });
    }
    case types.FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS: {
      const queryState = Object.assign({}, state.autocomplete[action.query], {
        isFetching: false,
        isLoaded: true,
        list: action.organizations,
      });

      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: queryState,
      });

      return Object.assign({}, state, { autocomplete });
    }

    case types.FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE: {
      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: {
          isFetching: false,
          isLoaded: false,
          list: [],
        },
      });

      return Object.assign({}, state, { autocomplete });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/organizations/index.js